import { useCallback, useRef, useState } from 'react';

import Modal from '../../common/Modal/Modal';

interface IProps {
  children: JSX.Element;
  side?: 'center' | 'right' | 'bottom';
  keepMounted?: boolean;
  preventNavigate?: boolean;
  size?: 'lg' | 'small';
  opaque?: boolean;
  skipFocus?: boolean;
}

interface IModalOptions {
  closeCallback?: () => unknown;
  keepOpen?: boolean;
}

const useModal = (options?: IModalOptions) => {
  const [isOpen, setIsOpen] = useState(false);
  const openBtnRef = useRef<{ element: HTMLButtonElement | null }>({ element: null });
  const closeCallback = useRef({
    f: () => {},
  });

  const open = useCallback((ref: HTMLButtonElement) => {
    openBtnRef.current.element = ref;
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    if (options?.closeCallback) options.closeCallback();
  }, [options]);

  const modal = useCallback(
    ({ children, side, keepMounted, preventNavigate, size, opaque, skipFocus }: IProps) => (
      <Modal
        isOpen={options?.keepOpen || isOpen}
        close={close}
        side={side}
        opaque={opaque}
        openBtn={openBtnRef.current.element}
        closeCallback={closeCallback}
        keepMounted={keepMounted}
        preventNavigate={preventNavigate}
        keepOpen={options?.keepOpen}
        size={size}
        skipFocus={skipFocus}
      >
        {children}
      </Modal>
    ),

    [close, isOpen, options],
  );

  return { isOpen, open, close, modal, openBtnRef, closeCallback };
};

export default useModal;
